'use client'

import React, { useEffect, useMemo, useState } from 'react'
import BottomSheet from '../../../../../BottomSheet'
import ChallanCard, { type ChallanListItem } from './challanCard'
import styles from './AllChallansBottomSheet.module.scss'

export type { ChallanListItem }

export type AllChallansBottomSheetProps = {
  isOpen: boolean
  challans: ChallanListItem[]
  /** Pre-formatted total (e.g. "₹3,500"). Computed from `challans` when omitted. */
  totalAmount?: string
  onClose: () => void
  onPayPress?: (totalAmount: string) => void
}

const formatAmount = (amount: number) =>
  `₹${amount.toLocaleString('en-IN', { maximumFractionDigits: 0 })}`

const toAmountNumber = (amount: number | string) => {
  const parsed = typeof amount === 'number' ? amount : Number(amount)
  return Number.isFinite(parsed) ? parsed : 0
}

const AllChallansBottomSheet = ({
  isOpen,
  challans,
  totalAmount,
  onClose,
  onPayPress,
}: AllChallansBottomSheetProps) => {
  const computedTotal = useMemo(
    () => formatAmount(challans?.reduce((sum, item) => sum + toAmountNumber(item.amount), 0) ?? 0),
    [challans]
  )
  const displayTotal = totalAmount ?? computedTotal
  const count = challans?.length
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null)

  useEffect(() => {
    if (!isOpen) setExpandedIndex(null)
  }, [isOpen])

  return (
    <BottomSheet isOpen={isOpen} onClose={onClose}>
      <div className={styles.bottomSheetContent}>
        <div className={styles.bottomSheetHeader}>
          <div className={styles.bottomSheetTitle}>
            {count} traffic fine{count === 1 ? '' : 's'}
          </div>
          <div className={styles.bottomSheetTotal}>{displayTotal}</div>
        </div>
        <div className={styles.bottomSheetList}>
          {challans.map((challan, index) => (
            <ChallanCard
              key={`${challan.title}-${index}`}
              {...challan}
              isExpanded={expandedIndex === index}
              onToggleExpand={() => setExpandedIndex(prev => (prev === index ? null : index))}
            />
          ))}
        </div>
        <button type="button" className={styles.bottomSheetCta} onClick={() => onPayPress?.(displayTotal)}>
          Pay challans on the app
        </button>
      </div>
    </BottomSheet>
  )
}

export default AllChallansBottomSheet
